import { ApiState, IApiState } from '../../shared/models/api-state.model';
import { ActionReducer, createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { ACE_TRANSCRIPTION_API_ACTIONS, AUDIO_API_ACTIONS, STANDARD_TRANSCRIPTION_API_ACTIONS } from '../actions';
import { IStandardTranscriptNormalized } from '../../shared/models/standard-transcript-normalized.model';
import { IAceTranscriptAPIResponse } from '../../shared/interfaces/ace-transcript.interface';

export const TRANSCRIPTION_STATE_KEY = 'transcription';

export interface ITranscriptionState {
  standardTranscription: IApiState<IStandardTranscriptNormalized>;
  aceTranscription: IApiState<IAceTranscriptAPIResponse>;
  audio: IApiState<string>;
}

export const initialState: ITranscriptionState = {
  standardTranscription: new ApiState(),
  aceTranscription: new ApiState(),
  audio: new ApiState(),
};

const reducer: ActionReducer<ITranscriptionState> = createReducer<ITranscriptionState>(
  initialState,
  on(
    STANDARD_TRANSCRIPTION_API_ACTIONS.get,
    (state): ITranscriptionState => ({
      ...state,
      standardTranscription: state.standardTranscription.load(),
    }),
  ),
  on(
    STANDARD_TRANSCRIPTION_API_ACTIONS.error,
    (state, { error }): ITranscriptionState => ({
      ...state,
      standardTranscription: state.standardTranscription.setError(error),
    }),
  ),
  on(
    STANDARD_TRANSCRIPTION_API_ACTIONS.success,
    (state, { data }): ITranscriptionState => ({
      ...state,
      standardTranscription: state.standardTranscription.success(data),
    }),
  ),
  on(
    AUDIO_API_ACTIONS.get,
    (state): ITranscriptionState => ({
      ...state,
      audio: state.audio.load(),
    }),
  ),
  on(
    AUDIO_API_ACTIONS.error,
    (state, { error }): ITranscriptionState => ({
      ...state,
      audio: state.audio.setError(error),
    }),
  ),
  on(
    AUDIO_API_ACTIONS.success,
    (state, { data }): ITranscriptionState => ({
      ...state,
      audio: state.audio.success(data),
    }),
  ),
  on(
    ACE_TRANSCRIPTION_API_ACTIONS.get,
    (state): ITranscriptionState => ({
      ...state,
      aceTranscription: state.aceTranscription.load(),
    }),
  ),
  on(
    ACE_TRANSCRIPTION_API_ACTIONS.error,
    (state, { error }): ITranscriptionState => ({
      ...state,
      aceTranscription: state.aceTranscription.setError(error),
    }),
  ),
  on(
    ACE_TRANSCRIPTION_API_ACTIONS.success,
    (state, { data }): ITranscriptionState => ({
      ...state,
      aceTranscription: state.aceTranscription.success(data),
    }),
  ),
);

export const TRANSCRIPTION_REDUCER = createFeature({
  name: TRANSCRIPTION_STATE_KEY,
  reducer,
  extraSelectors: ({ selectStandardTranscription, selectTranscriptionState }) => ({
    startDate: createSelector(selectStandardTranscription, ({ data }): string => data?.startDate || ''),
    hasAnyTranscription: createSelector(
      selectTranscriptionState,
      ({ standardTranscription, aceTranscription }): boolean =>
        Boolean(standardTranscription.data || aceTranscription.data),
    ),
  }),
});
